
export enum CommonStoreStatus {
    LOADING,
    ERROR,
    READY
}
